module.exports = __webpack_public_path__ + "static/media/background-srl.28854b90.png";